import request from '@/utils/request'
// import request01 from '@/utils/request01'

/** 文件上传 */
export function getuploadtoken() {
  return request({
    url: 'https://xcx.newacademic.net/admin/task/ststoken/',
    method: 'get'
  })
}

// 备选：走 admin 专用 request01，避免本地跨域时 newtoken 头触发 CORS
// export function getuploadtoken() {
//   return request01({
//     url: 'task/ststoken/',
//     method: 'get'
//   })
// }

// ocr识别
export function uploadocr(data) {
  return request({
    url: 'https://xcx.newacademic.net/api/literature/ImageOcr/',
    method: 'POST',
    headers:{
      "Content-Type": "multipart/form-data",
    },
    data
  })
}

// export function checkUpload(data) {
//   return request({
//     url: 'task/submittask/',
//     method: 'get',
//     params: data
//   })
// }
